import { Link as RouterLink } from 'react-router-dom';
import classes from './Link.module.scss';
import { CopyButton } from '../CopyButton/CopyButton';

interface LinkProps {
    isBlank: boolean;
    text: string;
    url: string | null | undefined;
    fallback?: string;
    showCopyButton?: boolean;
    copyText?: string;
    copyLabel?: string;
}

/** Показывает ссылку с необязательным копированием адреса */
export const Link: React.FC<LinkProps> = (
    {
        isBlank,
        text,
        url,
        fallback = '—',
        showCopyButton = false,
        copyText,
        copyLabel = 'Копировать ссылку',
    }
) => {
    if (!url) return <span>{fallback}</span>;

    return (
        <span className={classes.linkContainer}>
            <RouterLink
                to={url}
                target={isBlank
                    ? "_blank"
                    : undefined
                }
                className={classes.link}
                onClick={(e) => {
                    if (isBlank) {
                        e.preventDefault();
                        window.open(url, '_blank');
                    }
                }}
            >
                {text}
            </RouterLink>

            {showCopyButton && (
                <CopyButton
                    value={copyText || url}
                    label={copyLabel}
                />
            )}
        </span>
    );
};
